<template>
	<div>
		<el-dialog title="添加新地址" :visible.sync="show" show-close="true" @close="close">
			<el-form :model="form" ref="formName">
				<el-form-item label="收货人:">
					<el-input v-model="form.consignee" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="所在地区：">
					<el-cascader
					      size="large"
					      :options="options"
					      v-model="selectedOptions"
						  @change="handleChange"
					      >
					</el-cascader>
				</el-form-item>
				<el-form-item label="详细地址:">
					<el-input v-model="form.address" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="手机号码：">
					<el-input v-model="form.phone" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="邮编：">
					<el-input v-model="form.postcode" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="地址别名：">
					<el-input v-model="form.alias" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="confirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
	import {addressEdit} from '../api/index.js'
	export default {
		data() {
			return {
				form: {
					consignee: '',
					address: '',
					phone: '',
                    area_id:'',
                    postcode:'',
                    alias:''
				},
				selectedOptions: [],
				options: regionData,
			}
		},
		props:{
			show:{
				type:Boolean,
				default:false
			}
		},
		watch:{
			show:{
				handler(newValue){
					console.log(newValue)
					this.show = newValue
				},
				immediate: true,
				deep:true
			}
		},
		methods:{
			confirm(){
				let token = JSON.parse(localStorage.getItem('userInfo')).token
				addressEdit({...this.form,id: "0"},{'Content-Type':'application/json','token':token,'platform':'H5'}).then(res => {
					if(res.code == 1){
						this.$message({
							message: '添加成功',
							type: 'success'
                        })
                        this.$refs.formName.resetFields();
                        this.close()


					}else{
						this.$message.error(res.msg)
					}
				})

			},
			close(){
				this.show = false
				this.$emit('showNull')
			},
			handleChange(e){
				this.form.area_id = e[2]
			}
		}
	}
</script>
<stype>

</stype>



// WEBPACK FOOTER //
// src/components/address.vue